import { html, slotted } from "@microsoft/fast-element";
export const ContentIndicatorTemplate = html `
    <span class="icon-container" part="icon-container" aria-hidden="true">
        <slot name="icon"></slot>
    </span>
    <span class="label-container" part="label-container">
        <span class="label" part="label">
            <slot
                ${slotted({
    property: "defaultItems",
    filter: (node) => {
        var _a;
        return (node instanceof HTMLElement && node.offsetParent !== null) ||
            (node instanceof Text && !!((_a = node.textContent) === null || _a === void 0 ? void 0 : _a.trim().length));
    },
})}
            ></slot>
        </span>
    </span>
`;
